
import { TranslationSet } from '../types';

export const index: TranslationSet = {
  'index.hero.title': {
    en: 'Capture Every Milestone',
    ja: '全ての成長記録を残そう',
    es: 'Captura cada hito',
    zh: '记录每一个里程碑',
    fa: 'ثبت هر نقطه عطف'
  },
  'index.hero.subtitle': {
    en: 'Effortlessly create and share beautiful diary entries of your baby\'s journey with our AI-powered app.',
    ja: '私たちのAI搭載アプリで、赤ちゃんの成長日記を簡単に作成・共有しましょう。',
    es: 'Crea y comparte fácilmente hermosas entradas de diario del viaje de tu bebé con nuestra aplicación impulsada por IA.',
    zh: '使用我们的AI驱动应用程序，轻松创建和分享宝宝旅程的美丽日记条目。',
    fa: 'با استفاده از برنامه هوشمند ما، به راحتی یادداشت‌های زیبای دفتر خاطرات سفر کودک خود را ایجاد و به اشتراک بگذارید.'
  },
  'index.welcomeBack.title': {
    en: 'Welcome Back!',
    ja: 'おかえりなさい！',
    es: '¡Bienvenido de nuevo!',
    zh: '欢迎回来！',
    fa: 'خوش آمدید!'
  },
  'index.welcomeBack.subtitle': {
    en: 'Ready to capture more precious moments?',
    ja: 'もっと大切な瞬間を記録する準備はできましたか？',
    es: '¿Listo para capturar más momentos preciosos?',
    zh: '准备好捕捉更多珍贵时刻了吗？',
    fa: 'آماده‌اید تا لحظات ارزشمند بیشتری را ثبت کنید؟'
  },
  'index.welcomeBack.createEntry': {
    en: 'Create New Entry',
    ja: '新しいエントリーを作成',
    es: 'Crear nueva entrada',
    zh: '创建新条目',
    fa: 'ایجاد یادداشت جدید'
  },
  'index.welcomeBack.viewEntries': {
    en: 'View All Entries',
    ja: 'すべてのエントリーを表示',
    es: 'Ver todas las entradas',
    zh: '查看所有条目',
    fa: 'مشاهده همه یادداشت‌ها'
  },
  'index.chatbot.title': {
    en: 'Meet Nurse Amy, Your AI Assistant',
    ja: 'ナースエイミーに会いましょう、あなたのAIアシスタント',
    es: 'Conoce a la enfermera Amy, tu asistente de IA',
    zh: '认识艾米护士，您的AI助手',
    fa: 'با پرستار امی، دستیار هوشمند شما آشنا شوید'
  },
  'index.chatbot.subtitle': {
    en: 'Have questions about baby care, parenting tips, or how to use our app? Nurse Amy is here to help you 24/7, providing personalized guidance and answers to all your questions.',
    ja: '育児やアプリの使い方について質問がありますか？ナースエイミーが24時間体制であなたをサポートします。',
    es: '¿Tienes preguntas sobre el cuidado del bebé, consejos para padres o cómo usar nuestra aplicación? La enfermera Amy está aquí para ayudarte 24/7, brindando orientación personalizada y respuestas a todas tus preguntas.',
    zh: '对婴儿护理、育儿技巧或如何使用我们的应用程序有疑问？艾米护士全天候为您提供个性化指导和解答。',
    fa: 'سوالاتی درباره مراقبت از کودک، نکات فرزندپروری یا نحوه استفاده از برنامه ما دارید؟ پرستار امی ۲۴ ساعته آماده کمک به شما است و راهنمایی‌های شخصی‌سازی شده و پاسخ به تمام سوالات شما را ارائه می‌دهد.'
  },
  'index.chatbot.tryNow': {
    en: 'Chat with Nurse Amy',
    ja: 'ナースエイミーとチャット',
    es: 'Chatea con la enfermera Amy',
    zh: '与艾米护士聊天',
    fa: 'گفتگو با پرستار امی'
  },
  'index.premiumBenefits.title': {
    en: 'Unlock Premium Benefits',
    ja: 'プレミアム特典を解除',
    es: 'Desbloquea beneficios premium',
    zh: '解锁高级权益',
    fa: 'فعال‌سازی مزایای ویژه'
  },
  'index.premiumBenefits.subtitle': {
    en: 'Enhance your baby diary experience with our premium features.',
    ja: 'プレミアム機能で赤ちゃん日記の体験を向上させましょう。',
    es: 'Mejora tu experiencia de diario para bebés con nuestras funciones premium.',
    zh: '使用我们的高级功能增强您的宝宝日记体验。',
    fa: 'تجربه دفتر خاطرات کودک خود را با ویژگی‌های ویژه ما ارتقا دهید.'
  },
  'index.premiumBenefits.upgradeToPremium': {
    en: 'Upgrade to Premium',
    ja: 'プレミアムにアップグレード',
    es: 'Actualizar a Premium',
    zh: '升级到高级版',
    fa: 'ارتقا به نسخه ویژه'
  },
  'notFound.title': {
    en: 'Oops! We can\'t find the page you\'re looking for.',
    ja: 'お探しのページが見つかりませんでした。',
    es: '¡Ups! No podemos encontrar la página que estás buscando.',
    zh: '哎呀！我们找不到您要查找的页面。',
    fa: 'اوه! ما نمی‌توانیم صفحه‌ای که به دنبال آن هستید را پیدا کنیم.'
  },
  'notFound.subtitle': {
    en: 'The page doesn\'t exist or may have been moved.',
    ja: 'ページは存在しないか、移動された可能性があります。',
    es: 'La página no existe o puede haber sido movida.',
    zh: '该页面不存在或可能已被移动。',
    fa: 'این صفحه وجود ندارد یا ممکن است جابجا شده باشد.'
  },
  'notFound.home': {
    en: 'Home',
    ja: 'ホームに戻る',
    es: 'Inicio',
    zh: '主页',
    fa: 'خانه'
  },
  'notFound.back': {
    en: 'Go Back',
    ja: '前のページ',
    es: 'Regresar',
    zh: '返回',
    fa: 'بازگشت'
  },
  'notFound.createEntry': {
    en: 'Create Entry',
    ja: '日記を作成',
    es: 'Crear entrada',
    zh: '创建条目',
    fa: 'ایجاد یادداشت'
  }
};
